import { WithChildren } from '_metronic/helpers'
import { UserModalContextProvider } from '../FormUserModal/Context'

const Provider: React.FC<WithChildren> = ({ children }) => {
	return <UserModalContextProvider>{children}</UserModalContextProvider>
}

export default Provider
